import React from "react";
import { Coins } from "lucide-react";
import { TRUST_BADGES, NAV_LINKS } from "@/data/content";

const FOOTER_COLS = [
  { title: "Product", links: ["Shreedhan Gold", "Gold SIP", "AI Coach", "ShreeRound", "Gift Gold"] },
  { title: "For NRIs", links: ["Gold Remittance", "NRI Gold SIP", "Gold for Family", "Gold Wallet"] },
  { title: "Company", links: ["About", "Careers", "Press", "ShreeSeva Impact", "Contact"] },
  { title: "Legal", links: ["Privacy", "Terms", "Vault Audit", "Grievance", "Disclosures"] },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-ivory-light pt-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {/* trust badges */}
        <div className="grid gap-4 border-b border-amber-200/50 pb-12 sm:grid-cols-2 lg:grid-cols-4">
          {TRUST_BADGES.map((b) => (
            <div key={b.label} className="flex items-center gap-3 rounded-2xl border border-amber-200/40 bg-white/50 p-4">
              <b.icon className="h-5 w-5 text-gold" />
              <span className="text-sm font-medium text-charcoal">{b.label}</span>
            </div>
          ))}
        </div>

        {/* sitemap */}
        <div className="grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-gold via-gold-amber to-gold-rose">
                <Coins className="h-5 w-5 text-charcoal-deep" strokeWidth={2.2} />
              </span>
              <span className="font-serif text-2xl text-charcoal">Shreedhan</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-charcoal-soft">
              The gold wealth platform for the Indian world — rooted in tradition, powered by
              technology, borderless in reach.
            </p>
            <div className="mt-6 flex gap-3">
              {["in", "X", "ig", "yt"].map((s) => (
                <a
                  key={s}
                  href="#hero"
                  data-testid={`social-${s}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-amber-200/60 bg-white/60 text-sm font-semibold text-charcoal transition-colors hover:border-gold hover:text-gold"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>

          {FOOTER_COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-charcoal">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#hero" className="text-sm text-charcoal-soft transition-colors hover:text-gold">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* disclaimer */}
        <div className="border-t border-amber-200/50 py-8">
          <p className="text-xs leading-relaxed text-charcoal-soft/80">
            <span className="font-semibold text-charcoal-soft">Disclaimer:</span> Digital gold is not a bank
            deposit and is not covered by deposit insurance. The value of gold can go up or down and past
            performance is not indicative of future returns. Shreedhan is a fictional concept created for
            demonstration purposes. Please read all scheme-related documents carefully before investing.
          </p>
          <p className="mt-4 text-xs text-charcoal-soft/70">© {new Date().getFullYear()} Shreedhan. All rights reserved. Made with warmth for the Indian world.</p>
        </div>
      </div>

      {/* oversized wordmark */}
      <div className="pointer-events-none select-none overflow-hidden">
        <p className="translate-y-[18%] text-center font-serif text-[22vw] font-light leading-none tracking-tight text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.18)]">
          Shreedhan
        </p>
      </div>
    </footer>
  );
};
